module.exports = __webpack_public_path__ + "img/banner.95ea81cf.png";